import React from 'react';
import { Skeleton } from 'primereact/skeleton';
import { Card } from 'primereact/card';

const CatalogSkeleton = ({ type = 'grid', count = 12 }) => {
    const renderGridSkeleton = () => {
        return Array.from({ length: count }, (_, index) => (
            <div key={index} className="col-12 md:col-6 lg:col-3">
                <Card className="mb-3">
                    <div className="p-3">
                        {/* Imagen del producto */}
                        <Skeleton height="200px" className="mb-3" />
                        
                        {/* Nombre del producto */}
                        <Skeleton height="1.5rem" className="mb-2" />
                        <Skeleton height="1rem" width="70%" className="mb-3" />
                        
                        {/* Logos y especificaciones */}
                        <div className="flex gap-2 mb-3">
                            <Skeleton shape="circle" size="2rem" />
                            <Skeleton shape="circle" size="2rem" />
                            <Skeleton shape="circle" size="2rem" />
                        </div>
                        
                        {/* Especificaciones técnicas */}
                        <div className="flex gap-3 mb-3">
                            <Skeleton height="1rem" width="40%" />
                            <Skeleton height="1rem" width="40%" />
                        </div>
                        
                        {/* Precio */}
                        <div className="flex justify-content-between align-items-center mb-3">
                            <Skeleton height="1rem" width="30%" />
                            <Skeleton height="2rem" width="40%" />
                        </div>
                        
                        {/* Botones */}
                        <div className="flex gap-2">
                            <Skeleton height="2.5rem" className="flex-1" />
                            <Skeleton height="2.5rem" className="flex-1" />
                        </div>
                    </div>
                </Card>
            </div>
        ));
    };
    
    const renderListSkeleton = () => {
        return Array.from({ length: count }, (_, index) => (
            <div key={index} className="col-12">
                <Card className="mb-3">
                    <div className="flex align-items-center gap-3 p-3">
                        {/* Imagen del producto */}
                        <Skeleton width="180px" height="150px" className="flex-shrink-0" />
                        
                        {/* Información del producto */}
                        <div className="flex-1">
                            {/* Nombre */}
                            <Skeleton height="1.5rem" width="80%" className="mb-2" />
                            <Skeleton height="1rem" width="60%" className="mb-3" />
                            
                            {/* Logos */}
                            <div className="flex gap-2 mb-3">
                                <Skeleton shape="circle" size="1.5rem" />
                                <Skeleton shape="circle" size="1.5rem" />
                                <Skeleton shape="circle" size="1.5rem" />
                            </div>
                            
                            {/* Especificaciones */}
                            <div className="flex gap-4 mb-3">
                                <Skeleton height="1rem" width="25%" />
                                <Skeleton height="1rem" width="25%" />
                            </div>
                            
                            {/* Precios */}
                            <div className="flex align-items-center gap-3">
                                <Skeleton height="1rem" width="30%" />
                                <Skeleton height="2rem" width="40%" />
                            </div>
                        </div>
                        
                        {/* Botones */}
                        <div className="flex flex-column gap-2" style={{ minWidth: '140px' }}>
                            <Skeleton height="2rem" />
                            <Skeleton height="2rem" />
                        </div>
                    </div>
                </Card>
            </div>
        ));
    };
    
    const renderFiltersSkeleton = () => {
        return (
            <div className="p-3">
                {/* Filtros activos */}
                <div className="mb-3">
                    <Skeleton height="1rem" width="40%" className="mb-2" />
                    <div className="flex gap-1 mb-2">
                        <Skeleton height="1.5rem" width="60px" />
                        <Skeleton height="1.5rem" width="80px" />
                        <Skeleton height="1.5rem" width="70px" />
                    </div>
                </div>
                
                {/* Acordeón de filtros */}
                <div className="space-y-3">
                    {Array.from({ length: 3 }, (_, index) => (
                        <div key={index} className="mb-4">
                            <Skeleton height="2.5rem" className="mb-2" />
                            <div className="pl-3">
                                <Skeleton height="2rem" className="mb-2" />
                                <Skeleton height="2rem" className="mb-2" />
                                <Skeleton height="3rem" className="mb-2" />
                            </div>
                        </div>
                    ))}
                </div>
                
                {/* Botón aplicar */}
                <Skeleton height="3rem" className="mt-4" />
            </div>
        );
    };
    
    const renderHeaderSkeleton = () => {
        return (
            <div className="p-4">
                {/* Barra de búsqueda y controles */}
                <div className="flex flex-column md:flex-row gap-3 mb-4">
                    <Skeleton height="3rem" className="flex-1" />
                    <div className="flex gap-2">
                        <Skeleton height="3rem" width="200px" />
                        <Skeleton height="3rem" width="100px" />
                    </div>
                </div>
                
                {/* Información de resultados */}
                <div className="flex flex-column md:flex-row justify-content-between align-items-center mb-3">
                    <Skeleton height="1.5rem" width="300px" />
                    <div className="flex gap-2">
                        <Skeleton height="2rem" width="80px" />
                        <Skeleton height="2rem" width="100px" />
                        <Skeleton height="2rem" width="70px" />
                    </div>
                </div>
            </div>
        );
    };
    
    if (type === 'filters') {
        return renderFiltersSkeleton();
    }
    
    if (type === 'header') {
        return renderHeaderSkeleton();
    }
    
    return (
        <div className="grid">
            {type === 'list' ? renderListSkeleton() : renderGridSkeleton()}
        </div>
    );
};

export default CatalogSkeleton;
